<template>
 <div>
   <NavTop class="navbar">
     <template v-slot:headerImgRight >
       <div class="img_top_text">党委办公室</div>
     </template>
     <template v-slot:mainnavlist>
       <div class="nav" @click="navigateTo('/partyActive')">工作状态</div>
       <div class="nav" @click="navigateTo('/notice')">通知公告</div>
       <div class="nav" @click="navigateTo('/theory')">党建理论</div>
       <div class="nav" @click="navigateTo('/mind')">上级精神</div>
       <div class="nav" @click="navigateTo('/regime')">规章制度</div>
     </template>
   </NavTop>
   <DetailedPage
     :rightTitle="'工作动态'"
     :homeLink="{ to: '/', text: '首页' }"
     :workDynamicsLink="{ to: '/partyActive', text: '工作动态' }"
   >
     <!-- 使用 slot 添加自定义内容 -->
     <template v-slot:txt-content >
       <router-link class="router_link " to="/partyDetils">
         <div class="news" v-for="(item,index) in newsList" :key="index">
           <div class="new_title">{{item.title}}</div>
           <div class="new_date">{{item.date}}</div>
         </div>
       </router-link>
     </template>
   </DetailedPage>
 </div>
</template>

<script>
import NavTop from '../../../components/comcomponents/NavTop.vue'

export default {
  components: {
    NavTop
  },
  data () {
    return {
      newsList: [
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习（扩大）会议 集体学习《中共中央 国务院关于弘扬教育家精神 加强新时代',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
        {title: '学校召开党委理论学习中心组学习会议 专题学习全国教育大会精神',date: '2014-9-29'},
      ]
    }
  },
  methods: {
    navigateTo (path) {
      this.$router.push(path)
    }
  }
}
</script>
<style lang="less" scoped>
.nav:hover{
  background-color: #9E070E;
}
.news{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px ;
  margin-top: 20px;
}

.news:hover{
  color: #9e070e;
}

</style>



// WEBPACK FOOTER //
// src/views/Party/Active/index.vue